import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const tableHead = [
  "Sr.",
  "Campaign Name",
  "Campaign Type",
  "Campaign Status",
  "Actions",
];
const CampaignStatTable = ({ data, currentPage, itemsPerPage}) => {

  const navigate = useNavigate();
  const goToView = (id) => {

    navigate(`/view-campaign-stat/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.campaignName || "N/A"}</td>
                <td>{item?.campaignTemplateName || "N/A"}</td>
                <td>{item?.campaignStatus || "N/A"}</td>
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => goToView(item.campaignId)}
                  >
                    <BsArrowRightShort className="me-1" />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default CampaignStatTable;
